var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfileSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18 18.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1.824c0-.277.154-.664.375-.83.465-.35 1.034-.589 1.625-.721v-.402c-.596-.347-1-.985-1-1.723a2 2 0 0 1 4 0c0 .738-.404 1.376-1 1.723v.402c.591.132 1.16.371 1.625.721.221.166.375.553.375.83zM22 7H8a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1"
})));
export default SvgProfileSolid;